/** @format */

import React, { Fragment, useEffect, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { updateActiveIndexInfoCenter } from 'stateContainer/actions';

export default function InformationCenter({ text: { menu, content } }) {
  const {
    activeNav: { infoCenterIndex }
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const myRef = useRef(null);

  const executeScroll = () =>
    myRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  useEffect(() => {
    executeScroll();
  }, [infoCenterIndex]);

  function getLogo(index) {
    switch (index) {
      case 0:
        return 'image-infocenter-friamaklare.svg';

      case 1:
        return 'image-infocenter-vtec.svg';

      case 2:
        return 'image-infocenter-frilansfinance.svg';

      case 3:
        return 'image-loopia-min-logo.svg';

      case 4:
        return 'image-infocenter-hemnet.svg';
      default:
        break;
    }
  }

  return (
    <div className='infocenter-container'>
      <div className='infocenter-body'>
        <div className='infocenter-menu-container'>
          {menu.map((menuItem, index) => (
            <Fragment key={index}>
              <p
                onClick={() => dispatch(updateActiveIndexInfoCenter(index))}
                className={`infocenter-menu-item text1r ${
                  index === infoCenterIndex && 'infocenter-menu-item-active'
                }`}>
                <img src={`../images/${getLogo(index)}`} />
                {menuItem}{' '}
                {index === infoCenterIndex && (
                  <div className='infocenter-menu-polygon'></div>
                )}
              </p>
            </Fragment>
          ))}
        </div>
        <div className='infocenter-view-container' ref={myRef}>
          {content[infoCenterIndex].subheadings.map((subheading, index) => (
            <Fragment key={index}>
              <h2>{subheading}</h2>
              <p className='text1r infocenter-para-spacing'>
                {content[infoCenterIndex].paragraphs[index]}
              </p>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
